<script lang="ts">

  import {
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
  } from "$lib/components/ui/table"
  import type { OrderHistory } from "./../../_types"

  let {
    value,
  }: {
    value: OrderHistory
  } = $props()

  const monthColumns = $derived(value.columns.filter((column) => column.type === "month"))
  const yearColumns = $derived(value.columns.filter((column) => column.type === "year"))

</script>

<div class="max-h-(--history-height) overflow-auto">
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead class="sticky top-0 z-10 min-w-40 bg-background">Produk</TableHead>
        {#each monthColumns as column (column.date)}
          <TableHead class="sticky top-0 z-10 bg-background text-right whitespace-nowrap">
            {column.date.toDateFormat("MMM yy")}
          </TableHead>
        {/each}
        <TableHead class="sticky top-0 z-10 bg-background text-right">Total</TableHead>
        {#each yearColumns as column (column.date)}
          <TableHead class="sticky top-0 z-10 bg-background text-right whitespace-nowrap">
            {`Total ${column.date.toDateFormat("yyyy")}`}
          </TableHead>
        {/each}
      </TableRow>
    </TableHeader>
    <TableBody>
      {#each value.groups as group (group.id)}
        <TableRow>
          <TableCell
            colspan={value.columns.length + 2}
            class="font-medium bg-muted">
            {group.name}
          </TableCell>
        </TableRow>
        {#each group.products as product (product.id)}
          <TableRow>
            <TableCell>
              <div class="text-sm">{product.name}</div>
              <div class="text-xs text-muted-foreground">{product.number}</div>
            </TableCell>
            {#each product.values.slice(0, monthColumns.length) as number, index (index)}
              <TableCell class="text-right tabular-nums">
                {number === 0 ? "-" : number.toLocaleString("en-US")}
              </TableCell>
            {/each}
            <TableCell class="text-right tabular-nums">
              {product.total === 0 ? "-" : product.total.toLocaleString("en-US")}
            </TableCell>
            {#each product.values.slice(monthColumns.length) as number, index (index)}
              <TableCell class="text-right tabular-nums">
                {number === 0 ? "-" : number.toLocaleString("en-US")}
              </TableCell>
            {/each}
          </TableRow>
        {/each}
      {/each}
    </TableBody>
    <TableFooter>
      <TableRow>
        <TableCell class="font-semibold">Total</TableCell>
        {#each value.values.slice(0, monthColumns.length) as number, index (index)}
          <TableCell class="text-right tabular-nums font-semibold">
            {number === 0 ? "-" : number.toLocaleString("en-US")}
          </TableCell>
        {/each}
        <TableCell class="text-right tabular-nums font-semibold">
          {value.total === 0 ? "-" : value.total.toLocaleString("en-US")}
        </TableCell>
        {#each value.values.slice(monthColumns.length) as number, index (index)}
          <TableCell class="text-right tabular-nums font-semibold">
            {number === 0 ? "-" : number.toLocaleString("en-US")}
          </TableCell>
        {/each}
      </TableRow>
    </TableFooter>
  </Table>
</div>
